import React from "react";

const EMR = () => {
  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "900px",
        margin: "auto",
        lineHeight: "1.7",
        fontFamily: "Arial, sans-serif",
      }}
    >
        
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
        EMR: The State and Scope of Electronic Medical Records in Asian Countries and Business Opportunities
      </h1>
       <p style={{ textAlign: "justify" }}>
        <strong>Author:</strong> Chun H. Goh, EAIVision LLC
      </p>
 {/* Two image boxes */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          justifyContent: "center",
          margin: "30px 0",
          flexWrap: "wrap",
        }}
      >
        <img
          src="/emr1.png"
          alt="EMR Providers India"
          style={{
            width: "45%",
            minWidth: "280px",
            borderRadius: "10px",
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
          }}
        />
        <img
          src="/emr2.png"
          alt="Hospitals Using EMR"
          style={{
            width: "45%",
            minWidth: "280px",
            borderRadius: "10px",
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
          }}
        />
      </div>
      <h2 style={{ color: "darkgreen" }}>Introduction</h2>
       <p style={{ textAlign: "justify" }}>
        No doubt the western countries are the leaders in the EMR market both in terms of developed systems and EMS adoption. 
        While in Asia, it is growing but at a very slow rate.
      </p>
       <p style={{ textAlign: "justify" }}>
        “The level of penetration and adoption of hospital information systems in Asian countries such as Japan, South Korea, 
        Singapore and Australia are comparable to USA. However, majority of the hospitals in Asian countries such as India, 
        China, Thailand, Malaysia and Indonesia are still in the early stages of IT adoption.” 
        said <em>Sourabh Kankhar</em>, Research Analyst, Asia Pacific Healthcare Practice, Frost & Sullivan.
      </p>
       <p style={{ textAlign: "justify" }}>
        Some of the reasons why the West adopted it faster than India include increased patient awareness, government initiatives, 
        higher computer penetration, innovation, economic pressures, and legal accountability. 
        This paper studies these opportunities with a focus on the Indian market.
      </p>

      <h2 style={{ color: "darkgreen" }}>Major Players in the Area</h2>
       <p style={{ textAlign: "justify" }}>Some of the major EMR providers in India include:</p>
      <ul>
        <li>GE Healthcare</li>
        <li>IBA Health</li>
        <li>VEPRO</li>
        <li>Siemens</li>
        <li>Karishma Software</li>
        <li>Sobha Renaissance IT Pvt. Ltd.</li>
        <li>21st Century Healthcare Solutions</li>
        <li>Softlink International</li>
        <li>Prognosys</li>
        <li>Srishti Software</li>
        <li>CDAC</li>
        <li>Televital</li>
        <li>Akhil Systems Pvt. Ltd.</li>
        <li>Tata Consultancy Services</li>
        <li>iSOft</li>
      </ul>
       <p style={{ textAlign: "justify" }}><em>(2009 Data, eHealthonline)</em></p>

      <h3 style={{ color: "orange" }}>Some of the hospitals in India using EMR are:</h3>
      <ul>
        <li>Amrita Institute of Medical Sciences, Coimbatore</li>
        <li>Apollo Hospital, Chennai</li>
        <li>Artemis Healthsciences, Gurgaon</li>
        <li>Christian Medical College, Vellore</li>
        <li>Fortis Hospital, Mohali and Delhi</li>
        <li>Manipal Hospital, Bangalore</li>
        <li>Max Devki Devi Hospital, Delhi</li>
        <li>P D Hinduja Hospital, Mumbai</li>
        <li>Ruby Hall Clinic, Pune</li>
        <li>Sahyadari Hospital, Pune</li>
        <li>Sri Sathya Institute Of Higher Medical Sciences, Puttaparthi & Bangalore</li>
        <li>PGIMER, Chandigarh</li>
      </ul>
       <p style={{ textAlign: "justify" }}><em>(2009 Data, eHealthonline)</em></p>
       <p style={{ textAlign: "justify" }}><em>Note: Most hospitals in India use GE Healthcare.</em></p>

      <h2 style={{ color: "darkgreen" }}>The Market Size and Scope</h2>
       <p style={{ textAlign: "justify" }}>
       "Asia Pacific region is an emerging hub for the health informatics industry," according to Sourabh Kankhar, Research Analyst at Frost & Sullivan. He also identifies that market growth is high in China, Australia, Malaysia, Thailand, the Philippines and India. The fast growing Asia-Pacific healthcare industry offers huge potential for the health IT market in the future. Dr. Low Cheng Ooi of SingHealth believes that Asia is fast ramping up in the healhcare It industry because of several factors. Patients are more sophisticated, people are traveling a lot and medical tourism is up and coming. Countries with a high volume of medical tourism are very IT dependent and are leading the IT innovation. Dr.Low adds on "Nobody is going to go an institution where prescriptions are still handwritten. Patients expect a certain amount of sophistication in your care and delivery system."</p>
      <p style={{ color: "blue", textAlign: "justify" }}>
          <p style={{ color: "blue", textAlign: "justify", fontStyle: "italic" }}>
            "Nobody is going to go to an institution where prescriptions are still handwritten. 
              Patients expect a certain amount of sophistication in your care and delivery system."
    </p>
    <p style={{ textAlign: "right", fontWeight: "bold", color: "#0056b3" }}>
  -         Dr. Low Cheng Ooi, Chief Medical Informatics Officer (CMIO), SingHealth
    </p>
    </p>
     <p style={{ textAlign: "justify" }}>Now,let us have a look at one of the countries from the South Asia region, India. An IDC Health Insights report shows that ICT spending by the healthcare market in India is estimated to be US$300 million, giving it 12% year-over-year (YoY) growth over the 2009 figure of US$267.8 million. IDC Health Insights expects ICT spending to reach US$451 million by 2013. The healthcare industry in India is projected to grow 23 per cent per annum to touch US$77 billion by 2012 based on a report by Yes Bank and ASSOCHAM. The sector has registered a growth of 9.3 per cent between 2000-2009, comparable to the sectoral growth rate of other emerging economies such as China, Brazil and Mexico. According to the report, the growth in the sector would be driven by healthcare facilities, both private and public sector, medical diagnostic and pathlabs, medical insurance sector and medical tourism . Research by McKinsey points that driven by strong local demand, Indian healthcare market is expected to continue growing close to previously projected rates of 10 to 12 per cent. With average household consumption expected to increase by more than seven per cent per annum, the annual healthcare expenditure is projected to grow at 10 per cent and also the number of insured is likely to jump from 100 million to 220 million. All these numbers and drivers show that there is immense potential for the healthcare sector, together with the IT and peripheral industry to benefit from it.</p>


      {/* Market Image */}
      <div style={{ textAlign: "center", margin: "30px 0" }}>
        <img
          src="/emr4.png"
          alt="EMR Market Size"
          style={{
            width: "80%",
            maxWidth: "700px",
            borderRadius: "10px",
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
          }}
        />
      </div>

      <h2 style={{ color: "darkgreen" }}>Major Components of EMR</h2>
       <p style={{ textAlign: "justify" }}>
        At the moment, most companies only use EMR for billing and administrative purposes than the core healthcare functions. EMR is actually more than just administration and billing.
        Here are some of the EMR features:

      </p>

      <h3 style={{ color: "orange" }}>Administration</h3>
<ul>
  <li>Template management</li>
  <li>
    Security features:
    <ul>
      <li>User authentication</li>
      <li>Custom permissions</li>
      <li>Logging</li>
      <li>Unattended automatic backups</li>
      <li>Legal protection</li>
    </ul>
  </li>
  <li>
    Import and export:
    <ul>
      <li>Scans</li>
      <li>PDFs</li>
      <li>Other documents</li>
    </ul>
  </li>
</ul>

<h3 style={{ color: "orange" }}>Clerical</h3>
<ul>
  <li>
    Billing:
    <ul>
      <li>Support for ICD-9 codes</li>
      <li>Superbill desktop user interface</li>
      <li>EZClaim support for receivables</li>
      <li>Prints HCFA-1500 (CMS-1500) claims</li>
      <li>Prints patient statements</li>
    </ul>
  </li>
  <li>
    Document management:
    <ul>
      <li>Bulk scanning of old records</li>
      <li>Selective scanning of old records</li>
      <li>Paper charting</li>
      <li>Secure sharing within or across office locations</li>
      <li>Organized document storage</li>
      <li>Quick signing by providers</li>
      <li>Integration with fax, printer, digital camera, and medical devices</li>
    </ul>
  </li>
  <li>
    Scheduling:
    <ul>
      <li>Managing across offices</li>
      <li>Managing multiple providers</li>
      <li>Easy appointment search</li>
      <li>Dynamic updating</li>
    </ul>
  </li>
  <li>
    Communications:
    <ul>
      <li>Message prioritizing</li>
      <li>Patient demographics</li>
      <li>Transcriptions</li>
    </ul>
  </li>
</ul>

<h3 style={{ color: "orange" }}>Clinical</h3>
<ul>
  <li>
    Forms and templates:
    <ul>
      <li>Form creation and sharing</li>
      <li>Patient handouts</li>
      <li>Template creation</li>
    </ul>
  </li>
  <li>
    Prescription writing:
    <ul>
      <li>Handwriting enabled</li>
      <li>Prescription favorites list</li>
      <li>One-click refills</li>
      <li>One-click faxing to pharmacies</li>
      <li>Automatic calculation of BSA with dosing calculator</li>
    </ul>
  </li>
  <li>
    Histories:
    <ul>
      <li>One-click complete review</li>
      <li>Automatic staff updating</li>
    </ul>
  </li>
  <li>
    Messaging:
    <ul>
      <li>Message to front desk, other staff, or oneself</li>
    </ul>
  </li>
  <li>
    Progress notes:
    <ul>
      <li>Handwriting support</li>
      <li>Text support</li>
      <li>Voice recognition</li>
    </ul>
  </li>
  <li>
    Labs and tests:
    <ul>
      <li>Multi-format import</li>
    </ul>
  </li>
</ul>

<p style={{ marginTop: "1em" }}>
  To add on to these, according to the Institute of Medicine (IOM), EMR/EHR should possess 8 core capabilities such as:
</p>
 <p style={{ textAlign: "justify" }}>Most EMR users are hospitals, clinics, practitioners, health systems, etc. However, before selling , EMR companies should invest time and effort to educate the customers first.
There are several options that we can charge our customers, we can incur a one-time fee, and customers get to use the software forever. It is usually a high upfront fees. When there is an upgrade, they'll need to invest more on the software.  This is what most EMR firms do.
Another option would be to charge much less upfront, but we continue to receive subscription fees along the way. In this method, customers could receive frequent upgrades without having to make another big purchase.</p>
<ul>
  <li>
    We could provide implementation together with the software to make sure our customers are implementing and applying it effectively and efficiently. 
    We could charge them extra for implementation or we could make it a package, as in the software comes with implementation. 
    Customization, training, computer/network setup could be included in implementation or could be separated.
  </li>
  <li>
    We could also give our customers a free trial. If they really like it, they will come back for it.
  </li>
  <li>
    We could also provide/charge them for hardware such as Tablet PC, workstation or server.
  </li>
  <li>
    We could also provide/charge for ongoing support and maintenance.
  </li>
  <li>
    If possible, we could also provide/charge them with a performance measurement tool in which our customers could use to analyze and track their performance. 
    I think this would be a great asset and most customers would want this tool.
  </li>
</ul>

      <h2 style={{ color: "darkgreen" }}>Possible Clients:</h2>
       <p style={{ textAlign: "justify" }}>
       Currently, in India, most of the users of health information systems/EMR/EHR/HIS are large corporate hospitals. Therefore, there are still many other possible clients that are "untouched". But, we have to keep in mind that private companies play a greater role than public sector. Private sector accounts for more than 80% of total healthcare spending in India and they are expected to be financially stronger and well managed.
     </p>
      <p style={{ textAlign: "justify" }}>Now, here is the health care system in India and some of the possible clients divided by level and public or private:

      </p>
      <table
        border="1"
        cellPadding="8"
        style={{
          borderCollapse: "collapse",
          margin: "20px auto",
          textAlign: "center",
          width: "80%",
        }}
      >
        <thead style={{ background: "#f0f0f0" }}>
          <tr>
            <th>Level</th>
            <th>Public</th>
            <th>Private</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Primary</td>
            <td>PHCs(Primary Health Centers) and its sub centers</td>
            <td>Traditional Practitioners</td>
          </tr>
          <tr>
            <td>Secondary</td>
            <td>District Hospitals</td>
            <td>Private Clinics<br /> Small Nursing Homes</td>
          </tr>
          <tr>
            <td>Tertiary</td>
            <td>Teaching Hospitals</td>
            <td>Private Clinics<br />
                Nursing Homes<br />
            Corporate Hospitals</td>
          </tr>
        </tbody>
      </table>

      <h2 style={{ color: "darkgreen" }}>Compare it with the major players in the US:</h2>
       <p style={{ textAlign: "justify" }}>Some of the major EMR providers in US include:</p>
     <ul>
  <li>Cerner</li>
  <li>Computer Programs & Systems</li>
  <li>Eclipsys</li>
  <li>Epic</li>
  <li>GE Healthcare</li>
  <li>McKesson</li>
  <li>Meditech</li>
  <li>MedPlus</li>
  <li>QuadraMed Corporation</li>
  <li>Siemens</li>
  <li>iSoft</li>
  <li>Fujitsu Limited</li>
  <li>Philips Healthcare</li>
  <li>3M</li>
  <li>Dell</li>
  <li>Hewlett-Packett</li>
  <li>Wal-Mart</li>
</ul>

       <p style={{ textAlign: "justify" }}>
           From this list, we can see quite a number of familiar names that do not belong to the health care industry originally such as GE (Electric), Dell and Hewlett-Packett (Computer) and Wal-Mart (Retail).  However, the opportunities they see in the health care industry with the EMR lure them to join the health care IT scene. None of these big names want to miss out on the potential of the EMR market.
   For you guys who are curious about the top players in the market, according to the report from Kalorama Information, some of the big players that sells to hospitals are McKesson, Cerner, Eclipsys and MediTech while Allscripts, Epic, eClinicalworks, athenahealth and NextGen are among the leaders in sales to physicians, but no one dominates this market yet.
   Comparing the major players between India and US, there are several big names that are similar such as GE Healthcare, Siemens, iSoft. These are power houses that operate internationally.
      </p>

      <h2 style={{ color: "darkgreen" }}>Conclusion</h2>
       <p style={{ textAlign: "justify" }}>
       No doubt there is huge potential for growth and like most of the verticals this provides huge potential specially due to ever increasing middle class and population at large. People are becoming more sophisticated, healthcare spending is increasing, people are aging, therefore more people are getting sick, meaning better business for the healthcare industry, middle class income per capita is increasing, medical tourism is huge, and the healthcare industry is growing as a whole. Everything is moving to the right direction. Not to forget, we are looking at developing countries where the concept is still developing and there are not as many players as in developed countries. Therefore, we could enter the market and put ourselves in a strong position.
      </p>
       <p style={{ textAlign: "justify" }}>  It would be a great start to focus the EMR(Electronic Medical Record) portion of the EMS. But it would be wise to have more features to be  more appealing to clients such as practitioners, smaller hospitals, clinics, and small nursing homes. Most of these smaller operations are first time EMR buyers and with limited budget, this would be a good start for them to get into EMR. However, I do not think it would be too appealing to bigger corporate hospitals because they are already using EMR currently for this purpose and they would want to seek something extra and something that are more beneficial to them if we are to target them as clients. It would definitely be a profitable business if the smaller operations are exposed to the benefits of EMR and they feel they are ready to leave the traditional paper-and-pen behind and adopt this new method instead.
</p>
    </div>
  );
};

export default EMR;
